import { render, staticRenderFns } from "./BusDataTable.vue?vue&type=template&id=60c12175&scoped=true&"
import script from "./BusDataTable.vue?vue&type=script&lang=js&"
export * from "./BusDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BusDataTable.vue?vue&type=style&index=0&id=60c12175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c12175",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})
